import styled, { css } from 'styled-components';

interface ContainerProps {
  isFocused: boolean;
  isErrored: boolean;
}

export const Container = styled.div<ContainerProps>`
  background: transparent;
  padding: 16px;
  width: 100%;

  border-bottom: 2px solid #fff;
  color: #aaa;

  ${props =>
    props.isErrored &&
    css`
      border-color: #c53030;
    `}

  ${props =>
    props.isFocused &&
    css`
      border-color: #5eeddc;
    `}

  display: flex;
  align-items: center;

  & + div {
    margin-top: 8px;
  }

  textarea {
    background: transparent;
    flex: 1;
    border: 0;
    color: #fff;
    font-family: 'Avenir Next LT Pro Regular';
    font-size: 16px;
    margin-top: 20px;
    resize: vertical;

    &::-webkit-input-placeholder {
      color: #aaa;
      font-family: 'Avenir Next LT Pro Regular';
      font-size: 16px;
    }
  }
`;
